(() => {
  'use strict';
  const cleanups = new WeakMap();
  function init(root) {
    if (root.dataset.cueUiReady === 'true') return;
    root.dataset.cueUiReady = 'true';
    const life = new AbortController(), opts = { signal: life.signal };
    const on = (e,n,fn) => e?.addEventListener(n,fn,opts);
    const all = s => [...root.querySelectorAll(s)];
    let current = 0, lastFocus = null, zoomItems = [], zoomIndex = 0;
    const slides = all('[data-cue-gallery-slide]'), thumbs = all('[data-cue-gallery-thumb]');
    const lightbox = root.querySelector('[data-cue-lightbox]'), zoomImage = root.querySelector('[data-cue-lightbox-image]');
    const mediaBlocked = () => ['cod-open','preparing-cod','other-cod-open'].includes(root.dataset.cueState);
    const show = n => {
      if (!slides.length) return;
      current=(n+slides.length)%slides.length;
      slides.forEach((s,i)=>s.hidden=i!==current);
      thumbs.forEach((t,i)=>t.setAttribute('aria-pressed',String(i===current)));
    };
    thumbs.forEach((b,i)=>on(b,'click',()=>show(i)));
    all('[data-cue-gallery-step]').forEach(b=>on(b,'click',()=>show(current+Number(b.dataset.cueGalleryStep))));
    function zoom(n) {
      zoomIndex=(n+zoomItems.length)%zoomItems.length;
      const pic=zoomItems[zoomIndex]; zoomImage.src=pic.src; zoomImage.alt=pic.alt||'Buzo Element';
      all('[data-cue-lightbox-step]').forEach(b=>b.hidden=zoomItems.length<2);
    }
    function open(items,index,trigger) {
      if (!lightbox || !zoomImage || mediaBlocked()) return;
      zoomItems=items;lastFocus=trigger;zoom(index);root.dataset.cueMediaOpen='true';lightbox.showModal();
    }
    slides.forEach((b,i)=>on(b,'click',()=>open(slides.map(b=>{let img=b.querySelector('img');return {src:img.currentSrc||img.src,alt:img.alt}}),i,b)));
    all('[data-cue-zoom-image]').forEach(b=>on(b,'click',()=>{let img=b.querySelector('img');open([{src:img.currentSrc||img.src,alt:img.alt}],0,b)}));
    on(root.querySelector('[data-cue-lightbox-close]'),'click',()=>lightbox.close());
    on(lightbox,'click',e=>{if(e.target===lightbox)lightbox.close()});
    on(lightbox,'close',()=>{root.dataset.cueMediaOpen='false';zoomImage.removeAttribute('src');if(lastFocus?.isConnected)lastFocus.focus({preventScroll:true});lastFocus=null});
    on(lightbox,'keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();zoom(zoomIndex+(e.key==='ArrowLeft'?-1:1))}});
    all('[data-cue-lightbox-step]').forEach(b=>on(b,'click',()=>zoom(zoomIndex+Number(b.dataset.cueLightboxStep))));
    const rails={quote:root.querySelector('[data-cue-quote-track]'),colors:root.querySelector('[data-cue-colors-track]'),reviews:root.querySelector('[data-cue-reviews-track]')};
    function move(key,direction){const rail=rails[key];if(!rail)return;let first=rail.firstElementChild;const gap=parseFloat(getComputedStyle(rail).gap)||0;const step=(first?.getBoundingClientRect().width||rail.clientWidth)+gap;const max=rail.scrollWidth-rail.clientWidth;let to=rail.scrollLeft+direction*step;if(direction>0&&rail.scrollLeft>=max-3)to=0;if(direction<0&&rail.scrollLeft<3)to=max;rail.scrollTo({left:to,behavior:matchMedia('(prefers-reduced-motion:reduce)').matches?'instant':'smooth'})}
    all('[data-cue-rail-prev]').forEach(b=>on(b,'click',()=>move(b.dataset.cueRailPrev,-1)));
    all('[data-cue-rail-next]').forEach(b=>on(b,'click',()=>move(b.dataset.cueRailNext,1)));
    const heroButton=root.querySelector('.cue-product-copy .cue-buy');
    let observer=null;
    if(heroButton&&'IntersectionObserver'in window){
      const rect=heroButton.getBoundingClientRect();
      const visibleHeight=Math.max(0,Math.min(rect.bottom,innerHeight)-Math.max(rect.top,0));
      const visibleWidth=Math.max(0,Math.min(rect.right,innerWidth)-Math.max(rect.left,0));
      const initialRatio=rect.width*rect.height>0?visibleHeight*visibleWidth/(rect.width*rect.height):0;
      root.dataset.cueStickyVisible=String(initialRatio<.75||visibleHeight<48);
      observer=new IntersectionObserver(entries=>{for(const e of entries)root.dataset.cueStickyVisible=String(e.intersectionRatio<.75||e.intersectionRect.height<48)},{threshold:[0,.75,1]});
      observer.observe(heroButton);
    }
    const cleanup=()=>{life.abort();observer?.disconnect();if(lightbox?.open)lightbox.close();delete root.dataset.cueUiReady;delete root.dataset.cueMediaOpen;delete root.dataset.cueStickyVisible;cleanups.delete(root)};
    cleanups.set(root,cleanup);show(0);
  }
  const boot=()=>document.querySelectorAll('[data-cue-ui-root]').forEach(init);
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-cue-ui-root]').forEach(init));
  document.addEventListener('shopify:section:unload',e=>e.target.querySelectorAll('[data-cue-ui-root]').forEach(r=>cleanups.get(r)?.()));
  window.CosaUtilBuzoElementUI={init:boot};
})();
